"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var version_1 = require("../../utils/version");

var variable_replacement_1 = require("../../utils/variable-replacement");

var user_agent_1 = require("../../utils/user-agent");

var browsers_json_1 = __importDefault(require("../../fixtures/regexes/client/browsers.json"));

var browser_engine_json_1 = __importDefault(require("../../fixtures/regexes/client/browser_engine.json"));

var available_browsers_json_1 = __importDefault(require("./fixtures/available-browsers.json"));

var mobile_only_browsers_json_1 = __importDefault(require("./fixtures/mobile-only-browsers.json"));

var BrowserParser = function BrowserParser(options) {
  var _this = this;

  _classCallCheck(this, BrowserParser);

  this.options = {
    versionTruncation: 1
  };

  this.parse = function (userAgent) {
    var result = {
      type: "",
      name: "",
      version: "",
      engine: "",
      engineVersion: ""
    };

    var _iterator = _createForOfIteratorHelper(browsers_json_1.default),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var browser = _step.value;

        var _match = user_agent_1.userAgentParser(browser.regex, userAgent);

        if (!_match) continue;
        var vrpVersion = variable_replacement_1.variableReplacement(browser.version, _match);
        var version = version_1.formatVersion(vrpVersion, _this.options.versionTruncation);
        var shortVersion = version && parseFloat(version_1.formatVersion(vrpVersion, 1)) || "";

        if (browser.engine) {
          result.engine = browser.engine.default;

          if (browser.engine && browser.engine.versions && shortVersion) {
            var sortedEngineVersions = Object.entries(browser.engine.versions).sort(function (a, b) {
              return parseFloat(a[0]) > parseFloat(b[0]) ? 1 : -1;
            });

            var _iterator3 = _createForOfIteratorHelper(sortedEngineVersions),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _step3$value = _slicedToArray(_step3.value, 2),
                    versionThreshold = _step3$value[0],
                    engineByVersion = _step3$value[1];

                if (parseFloat(versionThreshold) <= shortVersion) {
                  result.engine = engineByVersion || "";
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }

        result.type = "browser";
        result.name = variable_replacement_1.variableReplacement(browser.name, _match);
        result.version = version;
        break;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (!result.engine) {
      var _iterator2 = _createForOfIteratorHelper(browser_engine_json_1.default),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var browserEngine = _step2.value;
          var match = null;

          try {
            match = RegExp(browserEngine.regex, "i").exec(userAgent);
          } catch (_a) {// TODO: find out why it fails in some browsers
          }

          if (!match) continue;
          result.engine = browserEngine.name;
          break;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    result.engineVersion = version_1.formatVersion(version_1.parseBrowserEngineVersion(userAgent, result.engine), _this.options.versionTruncation);
    return result;
  };

  this.options = Object.assign(Object.assign({}, this.options), options);
};

exports.default = BrowserParser;

BrowserParser.getBrowserShortName = function (browserName) {
  for (var _i = 0, _Object$entries = Object.entries(available_browsers_json_1.default); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        shortName = _Object$entries$_i[0],
        name = _Object$entries$_i[1];

    if (name === browserName) {
      return shortName;
    }
  }

  return "";
};

BrowserParser.isMobileOnlyBrowser = function (browserName) {
  return mobile_only_browsers_json_1.default.includes(BrowserParser.getBrowserShortName(browserName));
};